export default "__VITE_ASSET__CTpMVr8R__"